import React from "react";
import FeatherIcon from "feather-icons-react";

import { Styles } from "./styles";

interface Props {
  isSorted: boolean;
  isSortedDesc?: boolean;
}

const ColumnsSorter = ({ isSorted, isSortedDesc = false }: Props) => {
  const iconProps = {
    size: 14,
    strokeWidth: 2,
  };
  return (
    <Styles>
      <FeatherIcon
        icon="chevron-up"
        stroke={isSorted && !isSortedDesc ? "currentColor" : "#ccc"}
        {...iconProps}
      />
      <FeatherIcon
        icon="chevron-down"
        stroke={isSorted && isSortedDesc ? "currentColor" : "#ccc"}
        style={{ marginTop: -4 }}
        {...iconProps}
      />
    </Styles>
  );
};

export default ColumnsSorter;
